import { withStyles } from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';
import tw from 'twin.macro';

const TextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'currentColor',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'inherit',
      },
    },
    '& .MuiInputBase-root': tw`font-body`,
    '& .MuiInputLabel-root': tw`font-body`,
  },
})(MuiTextField);

const TwTextField = TextField;

export default TwTextField;
